// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WishLists-root-rApcX {
  padding-left: 20px;
  padding-right: 20px;
}

.WishLists-container-WSBXS {
  margin: 0px auto;
  padding-top: 30px;
  max-width: var(--max-container-width);
  padding-bottom: 50px;
}

@media screen and (max-width: 1200px) {
  .WishLists-mainSection-vOYIK {
    margin-bottom: 60px;
    margin-top: 30px;
  }

  .WishLists-container-WSBXS {
    padding-top: 75px;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/wishLists/WishLists.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".root {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.container {\n  margin: 0px auto;\n  padding-top: 30px;\n  max-width: var(--max-container-width);\n  padding-bottom: 50px;\n}\n\n@media screen and (max-width: 1200px) {\n  .mainSection {\n    margin-bottom: 60px;\n    margin-top: 30px;\n  }\n\n  .container {\n    padding-top: 75px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `WishLists-root-rApcX`,
	"container": `WishLists-container-WSBXS`,
	"mainSection": `WishLists-mainSection-vOYIK`
};
module.exports = ___CSS_LOADER_EXPORT___;
